module.exports = __webpack_public_path__ + "media/images/social-share-button/facebook-0ada3788990cda55b9ba332c39ac825b.svg";